export default "__VITE_ASSET__8fQ7Yz_A__"